/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualPrepaidAdjustmentTransaction
 */
export interface ManualPrepaidAdjustmentTransaction {
    /**
     * 
     * @type {string}
     * @memberof ManualPrepaidAdjustmentTransaction
     */
    prepaidAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPrepaidAdjustmentTransaction
     */
    backendUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualPrepaidAdjustmentTransaction
     */
    reason?: string;
}

/**
 * Check if a given object implements the ManualPrepaidAdjustmentTransaction interface.
 */
export function instanceOfManualPrepaidAdjustmentTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ManualPrepaidAdjustmentTransactionFromJSON(json: any): ManualPrepaidAdjustmentTransaction {
    return ManualPrepaidAdjustmentTransactionFromJSONTyped(json, false);
}

export function ManualPrepaidAdjustmentTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualPrepaidAdjustmentTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prepaidAccountId': !exists(json, 'prepaidAccountId') ? undefined : json['prepaidAccountId'],
        'backendUserId': !exists(json, 'backendUserId') ? undefined : json['backendUserId'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function ManualPrepaidAdjustmentTransactionToJSON(value?: ManualPrepaidAdjustmentTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prepaidAccountId': value.prepaidAccountId,
        'backendUserId': value.backendUserId,
        'reason': value.reason,
    };
}

